import React from "react";
import logoblanco from "../../../../img/solimat-logo.svg";

const ErrorDisplay = ({descripcionError}) => {



    return (
        <div className="remarkable_section bg-gray mt-5">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col">
                            <div className=" app-section">
                                <div className="container-img-mobileapp col-md-6 col-sm-12 p-5">
                                    <img src={logoblanco} alt="Imagen logo" />
                                </div>
                                <div className="container-text-mobileapp col-md-6 col-sm-12">
                                    <h2 className="section-title_big text-center">
                                        {descripcionError === null || descripcionError === "" ? "Error en el Servicio" : "Información"}
                                    </h2>
                                    <p className="descriptive-text text-center">
                                        {descripcionError === null || descripcionError === "" ? "Error al realizar la llamada del servicio, inténtalo más tarde o consulte con su gestor" : descripcionError}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default ErrorDisplay;
